import { buildTicks } from "./readiness";

const TICKS = buildTicks();

export const RefCard = ({ T, scan, cardStyle, cardRef, areaRef, camNote }) => (
  <div className="hc-area" ref={areaRef}>
    <div className="hc-card" ref={cardRef} style={cardStyle}>
      <div className="hc-L">
        <svg className="hc-ticks" viewBox="0 0 350 430" aria-hidden="true">
          {TICKS.map((t, k) => (
            <line key={k} ref={(el) => { scan.tickRefs.current[k] = el; }}
              x1={t.x1} y1={t.y1} x2={t.x2} y2={t.y2} stroke="#D3DAE3" strokeWidth="3" strokeLinecap="round" />
          ))}
        </svg>
        <div className="hc-window">
          <video ref={scan.videoRef} autoPlay playsInline muted aria-label={T.preview} />
          {camNote && <div className="hc-camnote">{camNote}</div>}
        </div>
      </div>
      <div className="hc-R">
        <div className="hc-photo">{scan.photo && <img src={scan.photo.url} alt={T.photo} />}</div>
        <span className="hc-okb" aria-hidden="true">
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
        </span>
      </div>
    </div>
  </div>
);
